import { Link } from '@tanstack/react-router';
import { Smartphone } from 'lucide-react';
import Flag from '~/partials/Flag';
import { UserTags } from '~/partials/Tags';
import { Tooltip, TooltipContent, TooltipTrigger } from '~/primitives/tooltip';
import { getCompletionTime } from '~/util';
import { LevelResolvedRecord } from '~/util/types/submissions';
import { VideoIcon } from './VideoIcon';
import { useLocaleDateString } from '~/util/hooks/useLocale';

export const LevelRecordEntry = ({
    record,
    showDetailsOnTheSide = false,
}: {
    record: LevelResolvedRecord;
    showDetailsOnTheSide?: boolean;
}) => {
    const localeDate = useLocaleDateString();

    const details = (
        <p className="clamp-[text-xs-base-clamp] text-secondary-light leading-none mb-1 ml-2">
            {record.completion_time && record.completion_time > 0
                ? getCompletionTime(record.completion_time)
                : localeDate(record.achieved_at)}
        </p>
    );
    return (
        <div className="flex justify-between items-center ">
            <div className="flex gap-x-1 items-center justify-start">
                {record.submitted_by.country ? (
                    <Link
                        className="transition-transform hover:scale-110 focus:scale-100 block w-max"
                        to={`/profile/country/$country`}
                        params={{
                            country: String(record.submitted_by.country),
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Flag
                            className="min-w-10 min-h-9 max-w-10 max-h-9"
                            countryCode={record.submitted_by.country}
                        />
                    </Link>
                ) : (
                    <Flag className="min-w-10 min-h-9 max-w-10 max-h-9" />
                )}
            </div>
            <div className="flex flex-col flex-1 ">
                <UserTags
                    className="py-0.5 px-1 ml-1 clamp-[text-xs-base-clamp] bg-transparent text-secondary-foreground"
                    item={record.submitted_by}
                />
                {!showDetailsOnTheSide && details}
            </div>

            <div className="flex justify-end gap-2 items-center">
                {record.mobile && (
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Smartphone />
                        </TooltipTrigger>
                        <TooltipContent>Mobile</TooltipContent>
                    </Tooltip>
                )}
                {showDetailsOnTheSide && details}
                {!record.hide_video && record.video_url && (
                    <a
                        href={record.video_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Open completion video"
                    >
                        <VideoIcon
                            className="w-13 h-11 hover:scale-105 transition-transform"
                            url={record.video_url}
                        />
                    </a>
                )}
            </div>
        </div>
    );
};
